import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { AbstractDialogManagerProperties } from "@lib/titan2/dist/game/view/properties/AbstractDialogManagerProperties";
import { MessageDialogProperties } from "../common/MessageDialogProperties";
import { PromptDialogProperties } from "../common/PromptDialogProperties";
import { RealityCheckDialogProperties, RealityCheckNoOptionsDialogProperties } from "../common/RealityCheckDialogProperties";
import { ResponsibleGamingDialogProperties } from "../common/ResponsibleGamingDialogProperties";
/**
 * DialogManagerTabletProperties.ts
 */
export class DialogManagerLandscapeProperties extends AbstractDialogManagerProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.mouseBlockerProperties = new MouseBlockerProperties(0x000000, 0.6, false);
        this.messageDialogProperties = new MessageDialogProperties();
        this.messageDialogProperties.scale.set(0.73);
        this.promptDialogProperties = new PromptDialogProperties();
        this.promptDialogProperties.scale.set(0.73);
        this.realityCheckDialogProperties = new RealityCheckDialogProperties();
        this.realityCheckDialogProperties.scale.set(0.73);
        this.realityCheckNoOptionsDialogProperties = new RealityCheckNoOptionsDialogProperties();
        this.realityCheckNoOptionsDialogProperties.scale.set(0.73);
        this.responsibleGamingDialogProperties = new ResponsibleGamingDialogProperties();
        this.responsibleGamingDialogProperties.scale.set(0.73);
    }
}
//# sourceMappingURL=DialogManagerLandscapeProperties.js.map